import { isNullOrUndefined } from "@app/shared/utility/isNullOrUndefined";

export const formatScore = (score: number | null | undefined): string =>
  score?.toFixed(1) ?? "---";

export const formatCount = (count: number | null | undefined): string =>
  count?.toLocaleString() ?? "---";

export const formatPercent = (percent: number | null | undefined): string =>
  !isNullOrUndefined(percent) ? `${percent}%` : "---";
